export default {
    path: '/changeroom',
    meta: {
        title: '切换房间',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/changeroom`),
}


// WEBPACK FOOTER //
// ./src/views/ChangeRoom/router.js